<script>
import { HorizontalBar } from 'vue-chartjs'

export default {
  extends: HorizontalBar
}
</script>
